export default __webpack_public_path__ + "static/media/Installation_Digital-small.b815ec51.jpeg";